module.exports = __webpack_public_path__ + "img/maj3.9c12ff5a.jpg";